import React from "react";
import { Box, TextField, Stack, IconButton, Tooltip } from "@mui/material";

import FilterListAltIcon from "@mui/icons-material/FilterListAlt";

const DateFilter = ({
  startDateTime,
  setStartDateTime,
  endDateTime,
  setEndDateTime,
  APICall,
}) => {
  return (
    <Box>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          label="Data e ora inizio"
          type="datetime-local"
          fullWidth
          value={startDateTime}
          onChange={(e) => setStartDateTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Data e ora fine"
          type="datetime-local"
          fullWidth
          value={endDateTime}
          onChange={(e) => setEndDateTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Tooltip title="Avvia ricerca filtri">
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              APICall();
            }}
            sx={{
              color: "success.main",
              alignSelf: "center",
              justifyContent: "center",
            }}
          >
            <FilterListAltIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default DateFilter;
